/** @format */

export interface StoreStockAmounts {
  bopis: number;
  shipToStore: number;
  inStore: number;
}

export interface IStorePickUpMessage {
  additionalInfo?: string;
  altButtonLabel?: string;
  altIcon?: string;
  closedStore?: boolean;
  disabled: boolean;
  displayNearbyMessage?: boolean;
  displayNumberLeftMessage?: boolean;
  displayTimer: boolean;
  displayToolTip?: boolean;
  doesStoreCloseLabelApply?: boolean;
  doesStoreClosedAdditionalInfoApply?: boolean;
  fullfillmentLabel?: string;
  icon?: string;
  isBopl?: boolean;
  isProductAvailableInStore?: boolean;
  isReadyToDisplay: boolean;
  label?: string;
  storeClosedAdditionalInfo?: string;
  storesClosedLabel?: string;
  style?: string;
  tooltip?: string;
  tooltipLabel?: string;
  useLimitedStockCss?: boolean;
}
